var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input-widget',{attrs:{"model":_vm.model,"attribute":_vm.attribute,"items":_vm.negotiationStatuses,"type":"select2","display-field":"${item.key}","value-field":"value","disabled":_vm.disabled,"options":{placeholder: _vm.$t('Select')}}})}
var staticRenderFns = []

export { render, staticRenderFns }